import * as React from "react";
const SvgFiRrHouseChimneyCrack = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-house-chimney-crack_svg__a)">
      <path
        fill="#062147"
        d="M22 5.724V2a1 1 0 1 0-2 0v2.366L14.797.855a4.98 4.98 0 0 0-5.594 0l-7 4.724A5 5 0 0 0 0 9.724V19c0 2.757 2.243 5 5 5h3.913c.822 0 1.572-.516 1.867-1.283l1.29-3.358a1.002 1.002 0 0 0-.933-1.36H8.381a.36.36 0 0 1-.323-.191.35.35 0 0 1 .007-.364l4.957-7.37a.17.17 0 0 1 .271-.008.16.16 0 0 1 .024.146l-1.369 4.497A.999.999 0 0 0 12.905 16h2.869c.097 0 .154.052.186.096a.22.22 0 0 1 .029.206l-1.74 5.045A2.002 2.002 0 0 0 16.14 24h2.861c2.757 0 5-2.243 5-5V9.724a5 5 0 0 0-2.001-4M22 19c0 1.654-1.346 3-3 3h-2.861l1.74-5.045a2.23 2.23 0 0 0-.291-2.02A2.24 2.24 0 0 0 15.774 14h-1.52l.977-3.206a2.15 2.15 0 0 0-.332-1.918A2.14 2.14 0 0 0 13.16 8c-.729 0-1.405.364-1.803.967l-4.96 7.374A2.367 2.367 0 0 0 8.381 20h1.301l-.769 2H5c-1.654 0-3-1.346-3-3V9.724c0-1 .494-1.93 1.322-2.487l7-4.724a2.985 2.985 0 0 1 3.355 0l7 4.724a3 3 0 0 1 1.322 2.487z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-house-chimney-crack_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrHouseChimneyCrack;
